'use strict';

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */

function Column(props) {
  return null;
}

Column.defaultProps = {
  width: 100
};
exports["default"] = Column;